




























































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

//  constants
import { currencyDefault } from '@/constants'

// services
import { RatesLunchService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { RateLunch } from '@/models/config'

@Component({
    name: 'TableListRatesLunch',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListRatesLunch extends Vue {
    loading = false
    items: [RateLunch] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'Nombre'
        },
        {
            key: 'price',
            sortable: true,
            label: 'Precio'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getRatesLunchWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getRatesLunchWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getRatesLunchWithPagination()
    }

    async getRatesLunchWithPagination () {
        this.loading = true
        const response = await RatesLunchService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }

    get currency () {
        return currencyDefault
    }
}
